// useScene - shared playback for the landing illustrations (components/scenes/*, HillScene).
// Plays once when the scene is 40 % in view. Nothing moves under prefers-reduced-motion.
// Default: sets `play`, and the scene's CSS keyframes run. If a GSAP build is available (anim/gsap.js)
// and the scene passes a timeline factory, `gsapOn` is set instead (which switches the CSS off) and
// timeline(gsap, svgRoot) drives the same [data-anim] parts.
import { ref, onMounted, onBeforeUnmount } from 'vue';
import { loadGsap } from './gsap';

export function useScene({ timeline = null, threshold = 0.4 } = {}) {
  const root = ref(null);
  const play = ref(false);
  const gsapOn = ref(false);
  let io = null;
  let tl = null;

  const reduced = () => !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  async function start() {
    if (reduced()) return;
    const gsap = timeline ? await loadGsap() : null;
    if (gsap && root.value) {
      gsapOn.value = true;
      tl = timeline(gsap, root.value);
      return;
    }
    play.value = true;
  }

  onMounted(() => {
    if (!root.value || !('IntersectionObserver' in window)) return;
    io = new IntersectionObserver((entries) => {
      if (entries.some((e) => e.isIntersecting)) { io.disconnect(); start(); }
    }, { threshold });
    io.observe(root.value);
  });
  onBeforeUnmount(() => {
    if (io) io.disconnect();
    if (tl && tl.kill) tl.kill();
  });

  return { root, play, gsapOn };
}
